import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgAmbulance = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M8.875 17.625V10.125C8.875 9.79348 9.0067 9.47554 9.24112 9.24112C9.47554 9.0067 9.79348 8.875 10.125 8.875H20.125C20.4565 8.875 20.7745 9.0067 21.0089 9.24112C21.2433 9.47554 21.375 9.79348 21.375 10.125V18.875C21.375 19.2065 21.2433 19.5245 21.0089 19.7589C20.7745 19.9933 20.4565 20.125 20.125 20.125H19.3933"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.875 17.7317V10.125H6.10083C5.82212 10.125 5.55141 10.2182 5.33172 10.3897C5.11203 10.5613 4.95597 10.8013 4.88833 11.0717L4.5 13.25L3.18167 14.1292C3.0108 14.2431 2.87062 14.3973 2.77353 14.5783C2.67644 14.7592 2.62543 14.9613 2.625 15.1667V18.875C2.625 19.2065 2.7567 19.5245 2.99112 19.7589C3.22554 19.9933 3.54348 20.125 3.875 20.125H6.48167"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.375 19.5C6.375 19.9973 6.57254 20.4742 6.92417 20.8258C7.27581 21.1775 7.75272 21.375 8.25 21.375C8.74728 21.375 9.22419 21.1775 9.57582 20.8258C9.92746 20.4742 10.125 19.9973 10.125 19.5C10.125 19.0027 9.92746 18.5258 9.57582 18.1742C9.22419 17.8225 8.74728 17.625 8.25 17.625C7.75272 17.625 7.27581 17.8225 6.92417 18.1742C6.57254 18.5258 6.375 19.0027 6.375 19.5V19.5Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.75 19.5C15.75 19.7462 15.7985 19.99 15.8927 20.2175C15.987 20.445 16.1251 20.6517 16.2992 20.8258C16.4733 20.9999 16.68 21.138 16.9075 21.2323C17.135 21.3265 17.3788 21.375 17.625 21.375C17.8712 21.375 18.115 21.3265 18.3425 21.2323C18.57 21.138 18.7767 20.9999 18.9508 20.8258C19.1249 20.6517 19.263 20.445 19.3573 20.2175C19.4515 19.99 19.5 19.7462 19.5 19.5C19.5 19.2538 19.4515 19.01 19.3573 18.7825C19.263 18.555 19.1249 18.3483 18.9508 18.1742C18.7767 18.0001 18.57 17.862 18.3425 17.7677C18.115 17.6735 17.8712 17.625 17.625 17.625C17.3788 17.625 17.135 17.6735 16.9075 17.7677C16.68 17.862 16.4733 18.0001 16.2992 18.1742C16.1251 18.3483 15.987 18.555 15.8927 18.7825C15.7985 19.01 15.75 19.2538 15.75 19.5V19.5Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.0183 20.125H15.8566"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.75 8.25C15.75 7.75272 15.5525 7.27581 15.2008 6.92417C14.8492 6.57254 14.3723 6.375 13.875 6.375C13.3777 6.375 12.9008 6.57254 12.5492 6.92417C12.1975 7.27581 12 7.75272 12 8.25V8.875H15.75V8.25Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.125 12V15.75"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.25 13.875H17"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.875 3.875V2.625"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17 5.125L17.625 3.875"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.75 5.125L10.125 3.875"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgAmbulance.displayName = 'SvgAmbulance';
export default SvgAmbulance;
